import { sidebarKeys } from '~/components/sidebar/utils/navigation-utils';
import { config } from '~/config/app.config';
import { create } from '~/utils/store/createStore';

export const SIDEBAR_CLOSED_WIDTH = '34px';
export const SIDEBAR_EXPANDED_WIDTH = '100px';

export type LsegPlatform = 'ws' | 'teams';

export interface AppStore {
  isSidebarExpanded: boolean;
  sidebarExpandConfig: Record<string, boolean>;
  setSidebarExpanded: (value: boolean) => void;
  setSidebarExpandConfig: (value: Record<string, boolean>) => void;
  lsegPlatform?: LsegPlatform;
  lsegDeepLink: typeof links.ppe | typeof links.prod;
  initialiseLsegEnv: () => void;
}

const LSEG_ENV_KEY = 'env';
const LSEG_PLATFORM_KEY = 'platform';

const { ppe, prod } = config.deepLink;
export const links = {
  ppe: {
    conversation: (id: string) => `${ppe.conversation}?conversationId=${id}`,
    entity: ppe.entity,
    chart: ppe.chart,
  },
  prod: {
    conversation: (id: string) => `${prod.conversation}?conversationId=${id}`,
    entity: prod.entity,
    chart: prod.chart,
  },
};

export const useApp = create<AppStore>(set => ({
  isSidebarExpanded: true,
  lsegPlatform: undefined,
  lsegDeepLink: links.prod,
  initialiseLsegEnv: () => {
    const params = new URLSearchParams(window.location.search);
    const url = new URL(window.location.href);
    const environment = params.get(LSEG_ENV_KEY);
    const platform = params.get(LSEG_PLATFORM_KEY);

    if (environment === 'ppe') {
      set({ lsegDeepLink: links.ppe });
    } else if (environment === 'prod') {
      set({ lsegDeepLink: links.prod });
    }

    if (platform === 'ws' || platform === 'teams') {
      set({ lsegPlatform: platform });
    }

    url.searchParams.delete(LSEG_ENV_KEY);
    url.searchParams.delete(LSEG_PLATFORM_KEY);
    window.history.replaceState(null, '', url);
  },
  sidebarExpandConfig: {
    [sidebarKeys.settings]: true,
    [sidebarKeys.screener]: true,
    [sidebarKeys.watchlist]: true,
    [sidebarKeys.quickAnalysis]: false,
    [sidebarKeys.document]: false,
    [sidebarKeys.stream]: true,
  },
  setSidebarExpanded: (value: boolean) => set({ isSidebarExpanded: value }),
  setSidebarExpandConfig: (value: Record<string, boolean>) =>
    set({ sidebarExpandConfig: value }),
}));
